// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `header {
  display: grid;
  grid-template-areas: "title version";
  padding: 16px;
  background-image: url('delta-widget.4f8b8c8583ee4fd7.svg');
  background-repeat: no-repeat;
  background-size: 80px;
  background-position-x: 0px;
  background-position-y: 10px;
  background-color: #2e1a47;
  min-height: 50px;
  color: #ffffff;
}

.title {
  grid-area: "title";
  align-self: center;
  font-size: 20px;
  margin-left: 80px;
}

.ficon-header-right {
  text-align: right;
  justify-content: center;
  display: flex;
  align-items: center;
  margin-left: auto;
}

.user {
  font-size: 14px;
  line-height: 14px;
  letter-spacing: 0.557143px;
  text-align: right;
}

.divider-header {
  min-height: 38px;
  border: 1px solid #404551;
  margin: 0 24px;
}

.hightlight-red {
  color: #e51937;
}

.logout {
  background-color: #e51937;
  color: #ffffff;
  border: #000000;
  min-height: 25px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/header/header.component.scss","webpack://./src/styles/_variables.scss"],"names":[],"mappings":"AAEA;EACE,aAAA;EACA,oCAAA;EACA,aAAA;EACA,0DAAA;EACA,4BAAA;EACA,qBAAA;EACA,0BAAA;EACA,2BAAA;EAEA,yBCXK;EDYL,gBAAA;EACA,cCZM;ADUR;;AAKA;EACE,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;AAFF;;AAKA;EACE,iBAAA;EACA,uBAAA;EACA,aAAA;EACA,mBAAA;EACA,iBAAA;AAFF;;AAKA;EACE,eAAA;EACA,iBAAA;EACA,0BAAA;EACA,iBAAA;AAFF;;AAKA;EACE,gBAAA;EACA,yBAAA;EACA,cAAA;AAFF;;AAKA;EACE,cAAA;AAFF;;AAKA;EACE,yBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AAFF","sourcesContent":["@import '../../../styles/variables';\n\nheader {\n  display: grid;\n  grid-template-areas: 'title version';\n  padding: $spacer;\n  background-image: url('../../../assets/delta-widget.svg');\n  background-repeat: no-repeat;\n  background-size: 80px;\n  background-position-x: 0px;\n  background-position-y: 10px;\n  // margin-bottom: $spacer;\n  background-color: $plum;\n  min-height: 50px;\n  color: $white;\n}\n\n.title {\n  grid-area: 'title';\n  align-self: center;\n  font-size: 20px;\n  margin-left: 80px;\n}\n\n.ficon-header-right {\n  text-align: right;\n  justify-content: center;\n  display: flex;\n  align-items: center;\n  margin-left: auto;\n}\n\n.user {\n  font-size: 14px;\n  line-height: 14px;\n  letter-spacing: 0.557143px;\n  text-align: right;\n}\n\n.divider-header {\n  min-height: 38px;\n  border: 1px solid #404551;\n  margin: 0 24px;\n}\n\n.hightlight-red {\n  color: #e51937;\n}\n\n.logout {\n  background-color: #e51937;\n  color: #ffffff;\n  border: #000000;\n  min-height: 25px;\n}\n","// Variables\n$plum: #2e1a47;\n$white: #ffffff;\n$light-gray: #e5e5e5;\n\n$spacer: 16px;\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
